import {getApiBase} from '../../config/apiBase';
import buildHeaders from './fetchHeaders';

export const API_BASE = getApiBase().replace(/\/$/, '') || '/api';

/**
 * Finds pitch reports visible to the current user that overlap with the source pitch
 * (shared Wikidata entities, with title-token fallback).
 */
export async function findSimilarPitches(reportId) {
    const response = await fetch(`${API_BASE}/reports/${encodeURIComponent(reportId)}/similar-pitches`, {
        method: 'GET',
        headers: buildHeaders({
            'Accept': 'application/json',
        }),
    });

    if (!response.ok) {
        let message = 'Failed to load similar pitches';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    const payload = await response.json();
    return Array.isArray(payload?.data) ? payload.data : [];
}
